import { render, staticRenderFns } from "./paperCertList.vue?vue&type=template&id=631b2ecd&scoped=true&"
import script from "./paperCertList.vue?vue&type=script&lang=js&"
export * from "./paperCertList.vue?vue&type=script&lang=js&"
import style0 from "./paperCertList.vue?vue&type=style&index=0&id=631b2ecd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b2ecd",
  null
  
)

export default component.exports